/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-02-14T10:35:36.027Z by lizhutang (lizhutang@spolo.org)

'use strict'

export default (editor, config = {}) => {
  const c = config
  let bm = editor.BlockManager
  let blocks = c.blocks

  if (blocks.stage) {
    bm.add('stage').set({
      label: c.labels.stage,
      category: 'Layout',
      attributes: { class: 'fa fa-eercast' },
      content: {
        type: 'stage',
        attributes: { 'lj-type': 'stage' }
        // content: '<div class="row"><div class="col"><div>这里插入文本</div></div></div>'
      }
    })
    bm.add('layer').set({
      label: c.labels.layer,
      category: 'Layout',
      attributes: { class: 'fa fa-newspaper-o' },
      content: {
        type: 'layer',
        style: { 'width': '50%', 'height': '50%' },
        attributes: { 'lj-type': 'layer' }
        // content: '<div class="row"><div class="col"><div>这里插入文本</div></div></div>'
      }
    })
    bm.add('frame').set({
      label: c.labels.frame,
      category: 'Layout',
      attributes: { class: 'fa fa-file-video-o' },
      content: {
        type: 'frame',
        // style: { 'min-height': '100vh' },
        attributes: { 'lj-type': 'frame', 'data-child-element': 'basic' }
        // content: '<div class="row"><div class="col"><div>这里插入文本</div></div></div>'
      }
    })
    bm.add('absolute').set({
      label: c.labels.absframe,
      category: 'Layout',
      attributes: { class: 'fa fa-file-video-o' },
      content: {
        type: 'absolute',
        style: { 'position': 'absolute', 'width': '50%', 'height': '100px' },
        attributes: { 'data-wwtype': 'absolute', 'data-child-element': 'basic' }
        // content: '<div class="row"><div class="col"><div>这里插入文本</div></div></div>'
      }
    })
  }
}
